import { render, staticRenderFns } from "./ModalElection.vue?vue&type=template&id=9b0e9ee4"
import script from "./ModalElection.vue?vue&type=script&lang=js"
export * from "./ModalElection.vue?vue&type=script&lang=js"
import style0 from "./ModalElection.vue?vue&type=style&index=0&id=9b0e9ee4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports